import { Space } from "antd";
import Search from "antd/es/input/Search";
import { Link } from "react-router-dom";
import AddIcon from "../../../assets/icons/AddIcon";
import ResourceTable from "../../../components/NP/Resource/ResourceTable";
import IconButton from "../../../components/common/IconButton";
import Subheader from "../../../components/ui/Subheader";
import useDebounce from "../../../hooks/useDebounce";
import useTable from "../../../hooks/useTable";
import AdminLayout from "../../../layouts/AdminLayout";
import { useAppSelector } from "../../../store/store";
import { AddZero } from "../../../utils/number";

export default function Resource() {
  const { usersCount, allUsers, loading } = useAppSelector(
    (state) => state.resource
  );
  const { keyword, handleInputChange, handleEnterValue } = useDebounce();
  const { handleSetFirstPage, ...rest } = useTable();
  // const handleSiteLocator = (value: string) => {
  //   console.log(`selected ${value}`);
  // };
  // const handleDateChange: DatePickerProps["onChange"] = (date, dateString) => {
  //   console.log(date, dateString);
  // };

  return (
    <AdminLayout title="Resources List" headerTitle="Resources">
      <section className="mt-7">
        <Subheader
          title="Resources List"
          subTitle={`Total Network: ${AddZero(
            keyword && !loading ? allUsers?.length : usersCount?.totalUsers
          )}`}
        >
          <Space size="middle">
            {/* <Select
              showSearch
              placeholder="Select a person"
              optionFilterProp="children"
              onChange={handleSiteLocator}
              filterOption={selectSearchOption}
              defaultValue="Inactive Networks"
              className="min-w-[8rem]"
              options={[
                {
                  value: "Inactive Networks",
                  label: "Inactive Networks",
                },
                {
                  value: "Pending",
                  label: "Pending",
                },
              ]}
            />
            <DatePicker onChange={handleDateChange} /> */}
            <Search
              placeholder="Search by name"
              onSearch={(val) => {
                handleEnterValue(val);
                handleSetFirstPage(true);
              }}
              onChange={(val) => {
                handleInputChange(val);
                handleSetFirstPage(true);
              }}
              className="custom-search-input"
            />

            <Link to="/sa/resource/add-resource">
              <IconButton type="primary" nextIcon={<AddIcon />}>
                Add new PG
              </IconButton>
            </Link>
          </Space>
        </Subheader>

        <ResourceTable
          keyword={keyword}
          handleSetFirstPage={handleSetFirstPage}
          {...rest}
        />
      </section>
    </AdminLayout>
  );
}
